@if (dialogData) {
	<section class="dialog-header">
		@if (dialogData.title) {
			<h1 mat-dialog-title>{{ dialogData.title }}</h1>
		}
		<button
			mat-icon-button
			class="close-button"
			[attr.aria-label]="'general.button.closeDialog' | translate"
			(click)="onCancel()">
			<mat-icon>close</mat-icon>
		</button>
	</section>
	<div mat-dialog-content>
		<p>{{ dialogData.message }}</p>
	</div>
	<mat-divider></mat-divider>

	<mat-dialog-actions>
		<button mat-button (click)="onCancel()">{{ dialogData.cancelButton }}</button>

		<button mat-flat-button (click)="onConfirm()">
			{{ dialogData.confirmButton }}
		</button>
	</mat-dialog-actions>
}
